
    
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FeatureIntroductionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserFeatureIntroduction"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isAiMarketingCalendarIntroduced"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"restaurantId"},"arguments":[],"directives":[]}]}}]};
  

    var useUnique = require('@graphql-tools/webpack-loader-runtime').useUnique;
    var unique = useUnique();
  

    module.exports = doc
  
